export const AttributeDescription = ({attr}: {attr: any}) => {
  return <span>{getAttributeDescription(attr)}</span>
}

export const getAttributeDescription = (attr: any) => {
  if (!attr) return null;
  if (attr.description) return attr.description;
  if (attr.validation) return `(${attr.validation.severity}) ${attr.validation.message}`;
  return null;
}